export default __webpack_public_path__ + "static/media/E_Elefante.c7829b1b.mp3";